<script>
import { cloneDeep } from 'lodash-es';
import { mapActions } from 'vuex';
import NonDynamicTransportTripConsumablesRow from './NonDynamicTransportTripConsumablesRow';

export default {
  name: 'NonDynamicTransportTripConsumables',
  components: {
    NonDynamicTransportTripConsumablesRow,
  },
  props: {
    tripId: {
      type: Number,
      default: null,
    },
    defaultTripConsumable: {
      type: Object,
      required: true,
    },
    tripConsumables: {
      type: Array,
      default: () => [],
    },
    tripConsumableTypes: {
      type: Array,
      required: true,
    },
    tripConsumablesLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localTripConsumables: [],
    };
  },
  created() {
    if (!this.tripConsumables.length) {
      this.addTripConsumableRow();
    } else {
      this.localTripConsumables = [...this.tripConsumables];
    }
  },
  watch: {
    tripConsumables: {
      handler(value) {
        const localStateTripConsumables = cloneDeep(value);
        this.localTripConsumables = [...localStateTripConsumables];
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      syncTransportTripConsumables: 'nonDynamicTransport/syncTransportTripConsumables',
    }),
    addTripConsumableRow() {
      this.localTripConsumables.push(cloneDeep(this.defaultTripConsumable));
    },
    removeTripConsumableRow(index) {
      const tripConsumables = [...this.localTripConsumables];
      tripConsumables.splice(index, 1);
      this.localTripConsumables = [...tripConsumables];
    },
    updateTripConsumableValues(event) {
      const tripConsumables = [...this.localTripConsumables];
      tripConsumables[event.index][event.attribute] = event.value;
      this.localTripConsumables = [...tripConsumables];
    },
    saveTripConsumables() {
      const payload = { tripConsumables: this.localTripConsumables, tripId: this.tripId };
      this.syncTransportTripConsumables(payload);
    },
  },
};
</script>

<template>
  <v-container class="pa-3">
    <v-layout class="mb-2">
      <h3>Consumables</h3>
    </v-layout>
    <v-progress-linear v-if="tripConsumablesLoading" :indeterminate="true"/>
    <non-dynamic-transport-trip-consumables-row
      v-else
      v-for="(tripConsumable, index) in localTripConsumables"
      :key="`non-dynamic-transport-consumables-${index}`"
      :index="+index"
      :trip-consumable="tripConsumable"
      :trip-consumable-types="tripConsumableTypes"
      @add="addTripConsumableRow"
      @remove="removeTripConsumableRow"
      @update="updateTripConsumableValues"
    />
    <v-layout>
      <v-flex>
        <v-btn
          class="right"
          color="success"
          @click="saveTripConsumables"
        >
          {{ $t('buttons.save') }} Consumables
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripConsumables.vue